export class AudioBufferClip
{
  _audioBuffer:AudioBuffer;
  _startSamplePosition:number;  
  _endSamplePosition:number;

  get startTime():number
  {
    return this._startSamplePosition / this._audioBuffer.sampleRate;
  }

  get endTime():number
  {
    return this._endSamplePosition / this._audioBuffer.sampleRate;
  }

  trimStart( treshold:number )
  {
    for ( let i = this._startSamplePosition; i < this._endSamplePosition; i++ )
    {
      for ( let c = 0; c < this._audioBuffer.numberOfChannels; c++ )
      {
        let data = this._audioBuffer.getChannelData( c )[ i ];

        if ( data > treshold )
        {
          this._startSamplePosition = i;
          return true;
        }
      } 
    }

    return false;
    
  }

  trimEnd( treshold:number )
  {
    for ( let i = this._endSamplePosition - 1; i >= this._startSamplePosition; i-- )
    {
      for ( let c = 0; c < this._audioBuffer.numberOfChannels; c++ )
      {
        let data = this._audioBuffer.getChannelData( c )[ i ];

        if ( data > treshold )
        {
          this._endSamplePosition = i + 1;
          return true;
        }
      } 
    }

    return false;
  }

  static createFromStartAndEndTime( buffer:AudioBuffer, startTime:number, endTime:number )
  {
    let clip = new AudioBufferClip();

    clip._audioBuffer  = buffer;
    clip._startSamplePosition = startTime * buffer.sampleRate;
    clip._endSamplePosition   = endTime   * buffer.sampleRate;

    return clip;
  }

  static create( buffer:AudioBuffer, startSamples:number, endSamples:number )
  {
    let clip = new AudioBufferClip();

    clip._audioBuffer  = buffer;
    clip._startSamplePosition = startSamples;
    clip._endSamplePosition   = endSamples;

    return clip;
  }

  
}